import React from "react";

const HighlightRibbonOne = () => {
  return (
    <>
      <section className="container-fluid container--ribbon__highlight">
        <div className="section-width card-wrapper">
          <div className="card card--highlight">
            <p className="numeral">7+</p>
            <p className="card-text card-text-highlight">years of experience</p>
          </div>
          <div className="card card--highlight">
            <p className="numeral">80+</p>
            <p className="card-text card-text-highlight">
              students life touched
            </p>
          </div>
          <div className="card card--highlight">
            <p className="numeral">1000+</p>
            <p className="card-text card-text-highlight">
              hours of interactive teaching
            </p>
          </div>
        </div>
      </section>
    </>
  );
};
export default HighlightRibbonOne;
